/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IFooterViewProps } from '@msdyn365-commerce-modules/footer';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IFooterItemProps } from '../definition-extensions/footer-item.ext.props.autogenerated';
import * as Msdyn365 from '@msdyn365-commerce/core';
/**
 *
 * FooterItemView component.
 * @extends {React.PureComponent<IFooterViewProps>}
 */
export class FooterItemView extends React.PureComponent<IFooterViewProps & IFooterItemProps<{}>> {
    public render(): JSX.Element | null {
        // eslint-disable-next-line @typescript-eslint/naming-convention -- Cannot change the prop names as props are from business logic.
        const { FooterItem } = this.props;
        return (
            <Module {...FooterItem}>
                {this._renderElement(this.props)}
            </Module>
        );
    }
    private _createImageMarkup(item: Msdyn365.IImageData, ariaHiddenAttr?: boolean): React.ReactNode | null {
        if (!item || !item.src || item.src.length === 0) {
            return null;
        }

        const defaultImageSettings: Msdyn365.IImageSettings = {
            viewports: {
                xs: { q: 'w=24&h=24&m=6', w: 0, h: 0 },
                lg: { q: 'w=24&h=24&m=6', w: 0, h: 0 }
            },
            lazyload: true
        };
        return (
            <Msdyn365.Image
                {...item}
                requestContext={this.props.context.request}
                gridSettings={this.props.context.request.gridSettings!}
                imageSettings={item.imageSettings || defaultImageSettings}
                loadFailureBehavior='default'
                aria-hidden={ariaHiddenAttr}
                editProps={{ key: this.props.config.image || {}, requestContext: this.props.context.request }}
                shouldSkipToMainImage
            />
        );
    }
    private _renderElement(props: IFooterViewProps & IFooterItemProps<{}>): React.ReactNode | null {
        // eslint-disable-next-line @typescript-eslint/naming-convention -- Cannot change the prop names as props are from business logic.
        const { heading, HeadingContainer, Link, linkText, image, text, EditableLink, config } = props;
        if (config.image && config.logoSvgUrl) {
            config.image.src = config.logoSvgUrl;
        }
        if (heading) {
            return (<Node {...HeadingContainer}>
                {' '}
                <Node tag='i' className='ms-footer__heading__title-icon' aria-hidden='true' />
                {heading}
                {' '}
            </Node>);
        } else if (Link && image) {
            return (
                <Node {...Link}>
                    {linkText}
                    {this._createImageMarkup(config.image!)}
                </Node>
            );
        } else if (Link) {
            return (EditableLink);
        }
        return (
            <>
                {text}
                {image}
            </>
        );
    }
}

export default FooterItemView;
